import React from 'react';
import { 
  HeroContainer, 
  HeroBg, 
  HeroInnerContainer, 
  HeroLeftContainer, 
  HeroRightContainer, 
  Label,
  Title, 
  SubTitle, 
  ButtonGroup,
  PrimaryButton,
  SecondaryButton,
  VisualContainer,
  MainImageWrapper,
  Img,
  ConnectionSVG,
  FloatingNode
} from './HeroStyle';
import HeroImgData from '../../images/HeroImage.jpg'
import { Bio } from '../../data/constants';
import { motion } from 'framer-motion';
import { Database, Cpu, Globe, Users, Trophy } from 'lucide-react';

const HeroSection = () => {
    const nodes = [
      { Icon: Database, top: '10%', left: '10%', delay: 0.2 },
      { Icon: Cpu, top: '5%', right: '5%', delay: 0.4 },
      { Icon: Globe, top: '83%', bottom: '20%', left: '9%', delay: 0.6 },
      { Icon: Users, bottom: '10%', right: '10%', delay: 0.8 },
      { Icon: Trophy, top: '40%', right: '-5%', delay: 1.0 },
    ];

    return (
        <div id="about">
            <HeroContainer>
                <HeroBg>
                    {/* Background grid or subtle patterns can go here */}
                </HeroBg>
                <HeroInnerContainer 
                    as={motion.div}
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 1.2 }}
                >
                    <HeroLeftContainer>
                        <Label
                            as={motion.div}
                            initial={{ opacity: 0, x: -20 }}
                            animate={{ opacity: 1, x: 0 }}
                            transition={{ duration: 0.6 }}
                        >
                            Future-Ready Product Strategy
                        </Label>
                        <Title
                            as={motion.div}
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.8, delay: 0.2 }}
                        >
                            Bridging the gap between <span>innovation</span> and execution.
                        </Title>
                        <SubTitle
                            as={motion.div}
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            transition={{ duration: 0.8, delay: 0.4 }}
                        >
                            Strategic Founder & Associate Product Manager specializing in 0→1→N product delivery, blending technical execution with human centric design to build, launch, and scale high-impact digital products.
                        </SubTitle>
                        
                        <ButtonGroup
                            as={motion.div}
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.8, delay: 0.6 }}
                        >
                            <PrimaryButton href="#projects">View Case Studies</PrimaryButton>
                            <SecondaryButton href={Bio.resume} target="_blank">Download Dossier</SecondaryButton>
                        </ButtonGroup>
                    </HeroLeftContainer>

                    <HeroRightContainer>
                        <VisualContainer>
                            <ConnectionSVG viewBox="0 0 500 500">
                              <motion.path 
                                d="M 0 0 L 500 500 M 500 0 L 0 500" 
                                stroke="rgba(133, 76, 230, 0.2)" 
                                strokeWidth="1" 
                                fill="none"
                                initial={{ pathLength: 0 }}
                                animate={{ pathLength: 1 }}
                                transition={{ duration: 2, repeat: Infinity, repeatType: "reverse" }}
                              />
                            </ConnectionSVG>
                            
                            <MainImageWrapper
                              as={motion.div}
                              initial={{ opacity: 0, scale: 0.8 }}
                              animate={{ opacity: 1, scale: 1 }}
                              transition={{ duration: 1, delay: 0.3 }}
                            >
                                <Img src={HeroImgData} alt="Rakesh Kumar" />
                            </MainImageWrapper>

                            {nodes.map((node, i) => {
                              const Icon = node.Icon;
                              return (
                                <FloatingNode
                                  key={i}
                                  style={{ 
                                    top: node.top, 
                                    left: node.left, 
                                    right: node.right, 
                                    bottom: node.bottom 
                                  }}
                                  initial={{ opacity: 0, scale: 0 }}
                                  animate={{ opacity: 1, scale: 1 }}
                                  transition={{ duration: 0.5, delay: node.delay }}
                                  whileHover={{ scale: 1.2, backgroundColor: '#854CE6', color: '#FFF' }}
                                >
                                  <Icon size={18} />
                                </FloatingNode>
                              );
                            })}
                        </VisualContainer>
                    </HeroRightContainer>
                </HeroInnerContainer>
            </HeroContainer>
        </div>
    )
}

export default HeroSection